import React from 'react'
import { IconButton, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import { BUILDER_V2_INK, BUILDER_V2_MUTED_TEXT, BUILDER_V2_HOVER_BACKGROUND } from '../../util'

interface ButtonOptionProps {
  label: string
  buttons: {
    icon: React.ReactNode
    onClick?: () => void
  }[]
  classes?: StyleClasses<typeof useStyles>
}

const useStyles = makeStyles<Theme, ButtonOptionProps>(
  (theme: Theme) => {
    return {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 44
      },
      label: {
        fontSize: '.8125rem',
        fontWeight: 500,
        marginRight: theme.spacing(3),
        color: BUILDER_V2_INK
      },
      button: {
        borderRadius: 5,
        height: 26,
        width: 26,
        fontSize: '.75rem',
        fontWeight: 500,
        color: BUILDER_V2_MUTED_TEXT,
        '& svg': {
          fontSize: '.875rem',
          color: BUILDER_V2_MUTED_TEXT
        },
        '&:hover': {
          background: BUILDER_V2_HOVER_BACKGROUND,
          color: BUILDER_V2_MUTED_TEXT
        },
        '&.Mui-disabled': {
          color: BUILDER_V2_MUTED_TEXT
        }
      },
      buttonGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }
    }
  },
  { name: 'ButtonOption' }
)

export default function ButtonOption(props: ButtonOptionProps) {
  const classes = useStyles(props)
  const { label, buttons } = props
  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant={'h5'}>
        {label}
      </Typography>
      <div className={classes.buttonGroup}>
        {buttons.map((button, index) => {
          return (
            <IconButton
              key={index}
              disabled={!button.onClick}
              onClick={button.onClick ? button.onClick : null}
              classes={{ root: classes.button }}
            >
              {button.icon}
            </IconButton>
          )
        })}
      </div>
    </div>
  )
}
